import { Component, Suspense, useEffect } from "react";
import { App as AntApp, Button, Result } from "antd";
import { RouterProvider } from "react-router-dom";
import AuthProvider from "./components/AuthProvider";
import Loading from "./components/loading";
import Router from "./constants/router";
import AppProvider from "./components/Providers/app";
import { getQsParam } from "./utils/string";

class ErrorBoundary extends Component<
  { children: React.ReactNode },
  { error: Error | null }
> {
  state = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
          <Result
            status="500"
            title="خطایی رخ داد"
            subTitle={(this.state.error as Error).message}
            extra={
              <Button type="primary" onClick={() => window.location.reload()}>
                بارگذاری مجدد
              </Button>
            }
          />
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  // Theme + ConfigProvider live in ThemeContext (single source of truth).
  return (
    <AntApp>
      <AuthProvider>
        <AppProvider>
          <InnerApp />
          <ErrorBoundary>
            <Suspense fallback={<Loading size="screen" text="در حال بارگذاری..." />}>
              <RouterProvider router={Router} />
            </Suspense>
          </ErrorBoundary>
        </AppProvider>
      </AuthProvider>
    </AntApp>
  );
}

function InnerApp() {
  const ERRORS = {
    NO_CHANNEL_FOUND:
      "کانال یوتیوبی به اکانت انتخاب شده متصل نیست، لطفا از این که اکانت درستی را انتخاب کرده‌اید اطمینان حاصل نمایید. درصورت حل نشدن مشکل با پشتیبانی تماس بگیرید.",
    NO_CHANNEL_CONNECTED:
      "کانالی متصل‌ نشد! در صورتی که مراحل را به درستی طی کرده‌اید لطفا با پشتیبانی تماس بگیرید.",
    ACCESS_TOKEN_SCOPE_INSUFFICIENT: "برای اتصال کانال باید دسترسی‌های خواسته شده را قبول کنید.",
  };
  const error = getQsParam("error");
  const { modal } = AntApp.useApp();
  useEffect(() => {
    if (error) {
      modal.error({
        title: "خطا",
        // @ts-ignore
        content: ERRORS[error] || error,
      });
    }
  }, [error, modal]);

  return null;
}

export default App;
